<p>{{ msg | translate }}</p>
